import { GiRocket } from "react-icons/gi";

/**
 * this function returns an render to be used in full page fatal messages
 * @returns JSX.Element.
 */
export function fullPageFatalError() {
  return (
    <div className="az-content pd-t-20 pd-b-20">
      <div className="az-content-body">
        <div className="row row-sm">
          <div className="col-md">
            <div className="card card-minimal-four">
              <div className="card-header">
                <div style={{ textAlign: "center" }}>
                  <span>
                    <GiRocket size={48} />
                  </span>
                  <h4>Houston, temos um problema!</h4>
                  <span>
                    Infelizmente, alguns dados não aterrissaram da maneira
                    correta.
                    <br />
                    <a href={"?"}>Clique aqui para tentar novamente.</a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
